// Spec §4.3: Extract useEffect logic for loading cursor display management
import { useEffect } from 'react';
import type { ButtonLoadingProps } from './types';

/**
 * Switches the page-wide cursor between the busy and normal states for a loading button.
 * Sets document.body's cursor to progress when isLoading is truthy and back to auto otherwise.
 *
 * @param isLoading - Whether the busy cursor should be shown.
 * @returns Nothing.
 */
const toggleLoadingCursor = (isLoading: any) => {
  if (isLoading) {
    document.body.style.cursor = 'progress';
  } else {
    document.body.style.cursor = 'auto';
  }
};

/**
 * Shows the global loading cursor while a loading button is mounted. Turns the cursor on when shouldDisplayLoadingCursor is set and turns it back off on unmount.
 *
 * @param props - Button props carrying shouldDisplayLoadingCursor.
 * @returns Nothing.
 */
export const useButtonLoading = (props: ButtonLoadingProps) => {
  useEffect(() => {
    if (props.shouldDisplayLoadingCursor) {
      toggleLoadingCursor(true);
      return () => {
        toggleLoadingCursor(false);
      };
    }
    return undefined;
  }, []);
};
